import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import ModalLogout from "../ModalLogout/ModalLogout";

const IdleTimer = ({ timeout }) => {
	const [isIdle, setIsIdle] = useState(false);
	const timerRef = useRef(null);
	const { signOut } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	const resetTimer = () => {
		if (timerRef.current) clearTimeout(timerRef.current);
		timerRef.current = setTimeout(() => {
			handleLogout();
		}, timeout);
	};

	const handleActivity = () => {
		if (isIdle) return;
		resetTimer();
	};

	useEffect(() => {
		if (location.pathname === "/login") {
			return;
		}
		resetTimer();
		const events = ["mousemove", "keydown", "mousedown", "touchstart"];
		events.forEach((e) => window.addEventListener(e, handleActivity));

		return () => {
			events.forEach((e) => window.removeEventListener(e, handleActivity));
			if (timerRef.current) clearTimeout(timerRef.current);
		};
	}, [location.pathname, timeout]);

	const handleLogout = () => {
		setIsIdle(true);
		signOut();
		navigate("/login");
	};

	return (
		<>
			{isIdle && (
				<ModalLogout
					message={`Por razões de segurança, sua sessão foi finalizada devido à inatividade por um período de ${timeout / 60000} minutos.`}
					onConfirm={() => setIsIdle(false)}
				/>
			)}
		</>
	);
};

export default IdleTimer;
